import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "spinner"]

  showSpinner() {
    this.buttonTarget.disabled = true
    this.spinnerTarget.classList.remove("hidden")
  }
}
